import { useEffect, useState } from 'react'
import { SwitchCamera } from 'lucide-react'
import { useVoiceStore } from '@/store/voice'

/** Сенсорный экран: телефон, планшет, ноутбук-трансформер — у них камеры бывают с двух сторон. */
const touchScreen = typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0

/**
 * Передняя или задняя камера — кнопка рядом с камерой, пока та включена. Только на сенсорных
 * экранах и только если камер больше одной. На обычном компьютере камеру выбирают в настройках,
 * а «перевернуть» там увело бы на вторую камеру из списка — чаще всего виртуальную, вроде OBS.
 */
export function CameraFlip({ className, size }: { className: string | undefined; size: number }) {
  const camera = useVoiceStore((s) => s.camera)
  const flipCamera = useVoiceStore((s) => s.flipCamera)
  const [cameras, setCameras] = useState(0)
  const [busy, setBusy] = useState(false)

  // все камеры браузер показывает только после разрешения на камеру — считаем, когда она включена
  useEffect(() => {
    const media = typeof navigator !== 'undefined' ? navigator.mediaDevices : undefined
    if (!camera || !touchScreen || !media?.enumerateDevices) return
    let alive = true
    const count = () => {
      media
        .enumerateDevices()
        .then((list) => {
          if (alive) setCameras(list.filter((d) => d.kind === 'videoinput').length)
        })
        .catch(() => undefined)
    }
    count()
    media.addEventListener('devicechange', count)
    return () => {
      alive = false
      media.removeEventListener('devicechange', count)
    }
  }, [camera])

  if (!camera || !touchScreen || cameras < 2) return null
  const flip = () => {
    setBusy(true)
    void flipCamera().finally(() => setBusy(false))
  }
  return (
    <button type="button" className={className} data-tooltip="Переключить камеру" aria-label="Переключить камеру" disabled={busy} onClick={flip}>
      <SwitchCamera size={size} />
    </button>
  )
}
